<template>
  <div>
    <TopNavigation />
    <div class="pa-10">
      <h2 class="contactTitle justify-center">Contact Us</h2>
      <div class="contactMessage mt-10">
        <p>Email: contact@kiraak.co</p>
        <!-- <p>Phone: 9347724926</p>
        <p><b>You can also visit us at our Warehouse</b></p>
        <p>C1, Survey Number: 318 Mankhal Road, Maheswaram Mandal, Tukkuguda, Hyderabad, Telangana - 501359</p> -->
      </div>
    </div>
  </div>
</template>
<script>
import TopNavigation from './TopNavigation.vue'
export default {
  name: 'ContactUs',
  components: {
    TopNavigation
  },
  data () {
    return {
    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>
<style scoped>
.contactMessage {
  color: #fdfaf1;
}
.contactTitle {
  color: #fdfaf1;
  font-size: 30px;
}
.contactSubTitle {
  color: #fdfaf1;
  font-size: 16px;
}
</style>
